import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  REST_API,
  ZAPIER,
  CHAT_GPT,
  APP_WRITE,
  XANO,
  SUPABASE,
  AIRTABLE,
  SALESFORCE,
  MYSQL,
} from 'drapcode-constant';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { apiTypeImages, snakeCaseToTitleCase } from '../../common/utils/api_utils';
class ExternalApiHeaderNav extends Component {
  showHeaders = () => {
    const { activeTab, projectId, icon, headers, version } = this.props;
    console.log('🚀 ~ ExternalApiHeaderNav ~ headers:', headers);
    if (!headers || headers.length === 0) {
      return '';
    }
    return headers.map((header) => {
      const title = snakeCaseToTitleCase(header);
      let image = apiTypeImages[header];
      return (
        <li key={header} className={`nav-item ${activeTab === header && 'active'}`}>
          <Link to={`/2.0/externalapi/${version}/v/${projectId}/`} className="nav-link">
            <span className="circle">
              <img
                src={require(`../../common/dataSource/img/${image}`)}
                width="18"
                height="18"
                alt={title}
              />
            </span>
            &nbsp;{title}
          </Link>
        </li>
      );
    });
  };
  render() {
    const { activeTab, projectId, title, icon, version, headers } = this.props;
    const enableChatGpt = this.props.enableChatGpt || false;
    return (
      <nav className="navbar navbar-expand-lg bg-primary">
        <div className="container">
          <div className="navbar-translate">
            <div className="navbar-brand">
              <i className={`wb ${drapcodeIcon(icon ? icon : 'ExternalAPIs')}`} size={'md'}></i>
              &nbsp;
              <span>{title ? title : 'External APIs'}</span>
            </div>
          </div>
          <div className="collapse navbar-collapse">
            <ul className="navbar-nav ml-auto">
              <li className={`nav-item ${activeTab === REST_API && 'active'}`}>
                <Link to={`/2.0/externalapi/${version}/v/${projectId}/`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../../common/dataSource/img/rocket.svg')}
                      width="18"
                      height="18"
                      alt={'REST API'}
                    />
                  </span>
                  &nbsp;REST API
                </Link>
              </li>
              <li className={`nav-item ${activeTab === ZAPIER && 'active'}`}>
                <Link to={`/2.0/externalapi/${version}/v/${projectId}/zapier`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../../common/dataSource/img/zapier.svg')}
                      width="18"
                      height="18"
                      alt="Zapier"
                    />
                  </span>
                  &nbsp;Zapier
                </Link>
              </li>
              {(activeTab === CHAT_GPT || enableChatGpt) && (
                <li className={`nav-item ${activeTab === CHAT_GPT && 'active'}`}>
                  <Link to={`/2.0/externalapi/${version}/v/${projectId}/chatGpt`} className="nav-link">
                    <span className="circle">
                      <img
                        src={require('../../common/dataSource/img/chatgpt-logo.png')}
                        width="18"
                        height="18"
                        alt={'ChatGPT'}
                      />
                    </span>
                    &nbsp;ChatGPT
                  </Link>
                </li>
              )}
              {(activeTab === APP_WRITE || headers.includes(APP_WRITE)) && (
                <li className={`nav-item ${activeTab === APP_WRITE && 'active'}`}>
                  <Link to={`/2.0/externalapi/${version}/v/${projectId}/appwrite`} className="nav-link">
                    <span className="circle">
                      <img
                        src={require('../../common/dataSource/img/appwrite.svg')}
                        width="18"
                        height="18"
                        alt="Appwrite"
                      />
                    </span>
                    &nbsp;Appwrite
                  </Link>
                </li>
              )}
              {(activeTab === XANO || headers.includes(XANO)) && (
                <li className={`nav-item ${activeTab === XANO && 'active'}`}>
                  <Link to={`/2.0/externalapi/${version}/v/${projectId}/xano`} className="nav-link">
                    <span className="circle">
                      <img
                        src={require('../../common/dataSource/img/xano.svg')}
                        width="18"
                        height="18"
                        alt="Xano"
                      />
                    </span>
                    &nbsp;Xano
                  </Link>
                </li>
              )}
              {(activeTab === SUPABASE || headers.includes(SUPABASE)) && (
                <li className={`nav-item ${activeTab === SUPABASE && 'active'}`}>
                  <Link to={`/2.0/externalapi/${version}/v/${projectId}/supabase`} className="nav-link">
                    <span className="circle">
                      <img
                        src={require('../../common/dataSource/img/supabase.svg')}
                        width="18"
                        height="18"
                        alt="Supabase"
                      />
                    </span>
                    &nbsp;Supabase
                  </Link>
                </li>
              )}
              {(activeTab === `XATA` || headers.includes(`XATA`)) && (
                <li className={`nav-item ${activeTab === `XATA` && 'active'}`}>
                  <Link to={`/2.0/externalapi/${version}/v/${projectId}/xata`} className="nav-link">
                    <span className="circle">
                      <img
                        src={require('../../common/dataSource/img/xata.svg')}
                        width="18"
                        height="18"
                        alt="Xata"
                      />
                    </span>
                    &nbsp;Xata
                  </Link>
                </li>
              )}
              {(activeTab === `DIRECTUS` || headers.includes(`DIRECTUS`)) && (
                <li className={`nav-item ${activeTab === `DIRECTUS` && 'active'}`}>
                  <Link to={`/2.0/externalapi/${version}/v/${projectId}/directus`} className="nav-link">
                    <span className="circle">
                      <img
                        src={require('../../common/dataSource/img/directus.svg')}
                        width="18"
                        height="18"
                        alt="Directus"
                      />
                    </span>
                    &nbsp;Directus
                  </Link>
                </li>
              )}
              {(activeTab === AIRTABLE || headers.includes(AIRTABLE)) && (
                <li className={`nav-item ${activeTab === AIRTABLE && 'active'}`}>
                  <Link to={`/2.0/externalapi/${version}/v/${projectId}/airtable`} className="nav-link">
                    <span className="circle">
                      <img
                        src={require('../../common/dataSource/img/airtable.svg')}
                        width="18"
                        height="18"
                        alt="Airtable"
                      />
                    </span>
                    &nbsp;Airtable
                  </Link>
                </li>
              )}
              {(activeTab === SALESFORCE || headers.includes(SALESFORCE)) && (
                <li className={`nav-item ${activeTab === SALESFORCE && 'active'}`}>
                  <Link
                    to={`/2.0/externalapi/${version}/v/${projectId}/salesforce`}
                    className="nav-link"
                  >
                    <span className="circle">
                      <img
                        src={require('../../common/dataSource/img/salesforce.svg')}
                        width="18"
                        height="18"
                        alt="Salesforce"
                      />
                    </span>
                    &nbsp;Salesforce
                  </Link>
                </li>
              )}
              {(activeTab === MYSQL || headers.includes(MYSQL)) && (
                <li className={`nav-item ${activeTab === MYSQL && 'active'}`}>
                  <Link to={`/2.0/externalapi/${version}/v/${projectId}/mysql`} className="nav-link">
                    <span className="circle">
                      <img
                        src={require('../../common/dataSource/img/mysql.svg')}
                        width="18"
                        height="18"
                        alt="MySQL"
                      />
                    </span>
                    &nbsp;MySQL
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
export default ExternalApiHeaderNav;
